import { convertCssValueToResolvedValue, CssValueOptions } from './convertCssValueToResolvedValue';

/**
 * Converts any CSS size value to its computed pixel value.
 *
 * This function can handle various CSS values including:
 * - Absolute units (px, pt, cm, mm, in)
 * - Relative units (rem, em, %, vh, vw)
 * - calc() expressions
 * - CSS variables
 * - Combinations of the above
 *
 * @param cssValue - The CSS value to convert (e.g., "1.5rem", "calc(100% - 20px)", "calc(2.5rem * var(--scale))")
 * @param options - Configuration options
 *
 * @example
 * // Convert font size
 * const fontSize = convertCssValueToPixelNumber('calc(2.5rem * var(--scale))', { property: 'fontSize' });
 *
 * // Convert width with specific context
 * const width = convertCssValueToPixelNumber('50%', {
 *   property: 'width',
 *   context: { width: '200px' }
 * });
 *
 * // Convert margin with specific element context
 * const margin = convertCssValueToPixelNumber('2em', {
 *   property: 'margin',
 *   element: document.getElementById('myElement')
 * });
 *
 * @returns The computed value in pixels
 */
export function convertCssValueToPixelNumber(cssValue: string | number, options: CssValueOptions): number {
  const resolvedValue = convertCssValueToResolvedValue(cssValue, options);
  return parseFloat(resolvedValue);
}
